import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';

interface Props {
  children: React.ReactNode;
}

function ImageWrapper({ children }: Props) {
  return (
    <>
      <div className="bg-gray-50 h-[150px] flex items-center justify-center rounded-md border border-gray-300">
        {children}
      </div>
      <p className="text-gray-500 text-[12px] font-normal mt-2 mb-4">
        <T kind="Upload an image file (PNG, JPG, GIF) that is 5mb in size or less" />
      </p>
    </>
  );
}

export default observer(ImageWrapper);
